import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Button from "../common/Button/Button";
import Fi from "../common/Field/Fi";
import { TextField, FormGroup, SwipeableDrawer } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import ReactCountryFlag from "react-country-flag";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuComponent from "../common/Menu/Menu";
import { MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const MobileReasonDrawer = ({ open, toggleDrawer }) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: {
          height: "400px",
          borderRadius: "16px 16px 0px 0px",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <CloseIcon
        onClick={() => toggleDrawer(false)}
        sx={{
          marginTop: "18px",
          marginLeft: "18px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          marginTop: "30px",
          marginBottom: "28px",
          textAlign: "center",
          rowGap: "24px",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          I am a seller
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          I am a buyer
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          I have a complain
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          I have a feedback
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          Take an appointment
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          Something else
        </Typography>
      </Box>
    </SwipeableDrawer>
  );
};

export default function ContactUsForm({ contactModalType }) {
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [reasonDrawer, setReasonDrawer] = React.useState(false);
  const handleReasonDrawer = (bool) => setReasonDrawer(bool);
  const [isFocused, setIsFocused] = React.useState(false);
  const [include, setInclude] = React.useState(false);
  const [also, setAlso] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [num, setNum] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [msg, setMsg] = React.useState("");
  const handleClear = () => {
    setInclude(false);
    setAlso(false);
    setName("");
    setEmail("");
    setCompany("");
    setNum("");
    setMsg("");
  };
  console.log(reasonDrawer);
  return (
    <>
      <>
        <Box
          sx={{
            width: { xs: "100%", sm: "553px" },
            outline: "none",
            backgroundColor: { xs: "#fff", sm: "" },
            padding: { xs: "24px 16px", sm: "" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexFlow: { xs: "column", sm: "row" },
              width: "100%",
              alignItems: "start",
            }}
          >
            <Typography
              variant={mobMatch ? "h3" : "subtitle1"}
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "22px", sm: "16px" },
                fontWeight: { xs: 600, sm: 600 },
                lineHeight: { xs: "26px", sm: "24px" },
                color: "text.primary",
                width: { xs: "100%", sm: "694px" },
                textAlign: { sm: "start" },
              }}
            >
              Contact Us
            </Typography>
            {mobMatch && (
              <Typography
                sx={{
                  color: "#616161",
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: { xs: "20px", sm: "24px" },
                }}
                variant={mobMatch ? "body2" : "body1"}
              >
                We would love to hear from you.
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              marginTop: { xs: "16px", sm: "16px" },
              width: { xs: "100%", sm: "553px" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexFlow: { xs: "column", sm: "row" },
                rowGap: "26px",
                columnGap: "26px",
              }}
            >
              <Fi
                sx={{ width: { xs: "100%", sm: "262px" }, height: "46.29px" }}
                size="small"
                height="46.29px"
                label="Full Name"
                value={name}
                handleChange={(e) => setName(e.target.value)}
              />

              <Fi
                sx={{ width: { xs: "100%", sm: "262px" }, height: "46.29px" }}
                label="Email Address"
                size="small"
                height="46.29px"
                value={email}
                handleChange={(e) => setEmail(e.target.value)}
              />
              {mobMatch && (
                <Fi
                  sx={{
                    width: "100%",
                  }}
                  label="Country"
                  size="small"
                  height="48px"
                  select={true}
                  children={<MenuItem>UAE</MenuItem>}
                />
              )}
            </Box>
            <Box
              sx={{
                flexFlow: { xs: "column", sm: "row" },
                rowGap: "26px",
                marginTop: "26px",
                display: "flex",
                columnGap: "26px",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "85px",
                    height: "46.29px",
                    backgroundColor: "#F5F5F5",
                    border: "1px solid #BFBFBF",
                    borderRight: "none",
                    borderRadius: "3px 0 0 3px",
                  }}
                >
                  <ReactCountryFlag countryCode="AE" svg />
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="primary.main"
                    sx={{ marginLeft: "5px" }}
                  >
                    +971
                  </Typography>
                </Box>
                <Fi
                  sx={{
                    width: { xs: "100%", sm: "177px" },
                    height: "46.29px",
                  }}
                  inputPropsSx={{
                    borderRadius: "0 3px 3px 0",
                  }}
                  label="Phone Number"
                  size="small"
                  height="46.29px"
                  value={num}
                  handleChange={(e) => setNum(e.target.value)}
                />
              </Box>
              {mobMatch && contactModalType !== "appointment" && (
                <Button
                  size={"small"}
                  typoSize="16px"
                  typoVariant={"body1"}
                  txColor="#616161"
                  fontWeight={400}
                  sx={{
                    height: "48px",
                    width: "100%",
                    border: "1px solid #BFBFBF",
                    justifyContent: "space-between",
                  }}
                  endIcon={
                    <KeyboardArrowDownIcon
                      sx={{ fontSize: "24px", color: "#808080" }}
                    />
                  }
                  variant={"outline"}
                  onClick={() => handleReasonDrawer(true)}
                >
                  Select Reason
                </Button>
              )}
              {mobMatch && contactModalType === "appointment" && (
                <Fi
                  filled={true}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      border: "1px solid #255CCE !important",
                    },
                    backgroundColor: "#255CCE1A",
                    width: { xs: "100%", sm: "177px" },
                    height: "48px",
                  }}
                  inputPropsSx={{
                    borderRadius: "4px",
                  }}
                  labelColor="primary.main"
                  label="Take an appointment"
                  size="small"
                  height="48px"
                  children={<MenuItem>Something</MenuItem>}
                  select={true}
                  // value={num}
                  // handleChange={(e) => setNum(e.target.value)}
                />
              )}
              {!mobMatch && (
                <MenuComponent
                  buttonVariant={"outlined"}
                  text="Select reason"
                  buttonStyle={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "264px",
                    height: "48px",
                  }}
                  textStyle={{
                    color: "#616161",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  paperStyle={{ width: "264px" }}
                  textVariant="body1"
                  icons={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
                >
                  <MenuItem>I am a seller</MenuItem>
                  <MenuItem>I am a buyer</MenuItem>
                  <MenuItem>I have a complain</MenuItem>
                  <MenuItem>I have a feedback</MenuItem>
                  <MenuItem>Take an appointment</MenuItem>
                  <MenuItem>Something else</MenuItem>
                </MenuComponent>
              )}
            </Box>
            <TextField
              multiline
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              label={
                !isFocused &&
                msg.length == 0 && (
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="#616161"
                  >
                    Your Message
                  </Typography>
                )
              }
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  padding: "0px",
                },
                "& .MuiOutlinedInput-input": {
                  minHeight: "88px",
                  color: "black",
                  padding: "11px 13px",
                },
                marginTop: "26px",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              marginTop: "24px",
              width: "100%",
            }}
          >
            <Button
              hoverBg={"#F3C04F"}
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{
                height: "48px",
                width: { xs: "100%", sm: "336px" },
                boxShadow: "none",
              }}
              onClick={() => {}}
            >
              Send Message
            </Button>
            
          </Box>
        </Box>
        <MobileReasonDrawer
          open={reasonDrawer}
          toggleDrawer={handleReasonDrawer}
        />
      </>
    </>
  );
}
